// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"m6-z"};